import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
import { AbstractBlock } from '../AbstractBlock';
import { ColorSettings } from '../setting/ColorSettings';
import { ShapeSettings } from '../setting/ShapeSettings';

const t = block_translation;
export class CommentOutBlock extends AbstractBlock {
  constructor() {
    super('comment-out', t.to('コメントアウト', 'comment_out'));
  }

  defineBlock(block: BlockType): void {
    ColorSettings.setLogicColor(block);
    ShapeSettings.setSceneStartShape(block);
    block.appendDummyInput().appendField(t.to('コメントアウト', 'comment_out'));
    ShapeSettings.addAttributeInput(block);
    ShapeSettings.addStatementInput(block);
  }

  codeGenerateCore(): string {
    const str = ``;
    return str;
  }
}
